 <template>
 <el-container class="flex flex-row w-full h-full">
  <el-header class="flex flex-row h-[80px] bg-[#F3F5F7]">
    <div class="bg-no-repeat w-[100px] h-[34px] ml-4 mt-3 bg-cover bg-no-repeat cursor-pointer" style="background-image:url(/images/bst.png);background-size:contain" @click="goHome">
    </div>
    <div class="flex-1"></div>
    <div class="flex flex-row items-center">
      <img src="/images/language.png" class="w-[16px] h-[16px] mr-[10px]"/>
      <span class="text-center text-sm leading-[60px] pr-[20px] text-[#6d6d6d]">简体中文</span>
    </div>
  </el-header>

  <el-main class="w-full bg-[#fafafa]">
    <div class="flex flex-row h-full">
      <div class="flex-1 flex justify-center items-center">
        <div class="w-[450px] bg-white px-[48px] py-[48px] flex flex-col" v-show="active === 0">
          <div class="flex flex-row">
            <div class="flex-1">
              <span class="text-[18px]">欢迎注册E链签</span>
            </div>
            <div class="flex-0 flex flex-row">
              <div><span class="text-[14px]">已有账号？</span></div>
              <div><el-link type="primary" href="/">返回登录</el-link></div>
            </div>
          </div>
          <div>
            <el-input v-model="mobile" placeholder="请输入手机号" class="pt-[20px] pb-[10px]"></el-input>
            <el-input v-model="code" maxlength="4" placeholder="请输入动态验证码" class="pt-[10px] pb-[10px]"><el-button slot="append" style="font-weight:normal;color:#4f94f7" @click="handleGetVerifyCode()">获取验证码</el-button>
            </el-input>
            <!-- <el-input v-model="password" show-password placeholder="设置登录密码" class="pt-[15px] pb-[10px]"></el-input>
            <el-input v-model="rePassword" show-password placeholder="再次确认密码" class="pt-[15px] pb-[10px]"></el-input> -->
            <el-checkbox v-model="agree">我已阅读并同意<a href="#" class="text-[#4f94f7]">《服务协议》</a><a href="#" class="text-[#4f94f7]">《隐私政策》</a></el-checkbox>
          </div>
          <div class="mt-[20px]">
            <el-button type="primary" @click="handleRegister" class="w-full">同意协议并注册</el-button>
          </div>
        </div>

       <div class="flex flex-col bg-white w-[450px] px-[48px] py-[48px]" v-show="active === 1">
          <div class="flex flex-row justify-center items-center">
            <div class="flex items-center h-[25px] mr-[10px]">
              <el-image class="w-[25px] h-[25px]" src="/images/success.png" fit="contain"></el-image>
            </div>
            <div class="flex-1">
              <span class="text-[18px] leading-[25px]">手机验证通过，请设定登录密码</span>
            </div>
          </div>
          <div>
          <el-input v-model="password" show-password placeholder="输入登录密码" class="pt-[15px] pb-[10px]"></el-input>
            <el-input v-model="rePassword" show-password placeholder="再次确认密码" class="pt-[15px] pb-[10px]"></el-input>
          </div>
          <div class="mt-[20px]">
            <el-button type="primary" @click="handleSetPassword" class="w-full">确  定</el-button>
          </div>
        </div>

        <div class="w-[450px] bg-white px-[48px] py-[48px] flex flex-col text-center" v-show="active === 2">
          <div class="m-[20px] flex-0">
            <el-image class="w-[50px] h-[50px]" src="/images/success.png" fit="contain"></el-image>
          </div>
          <div class="mb-[10px] flex-0"><span class="text-[20px]">注册成功</span></div>
          <div class="mt-[20px] flex-0">
            <el-button type="primary" @click="goHome" class="w-full">返回登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
  <el-footer class="h-[45px] bg-[#F3F5F7]">
    <div class="flex justify-center items-center">
      <div class="leading-[45px] pr-[20px] mr-[20px] text-xs text-[#6d6d6d]">Copyright @2024 南京百市通数码科技有限公司</div>
      <div class="leading-[45px] pr-[20px] mr-[10px] text-xs text-[#6d6d6d] sm:block hidden"><a href="#">苏ICP备2023011354号</a></div>
    </div>
  </el-footer>
 </el-container>
</template>

<script>
import { 
  getVerifyCode,
  register,
  registerPassword,
} from '@/api/api';
import {
  ErrorRegisterExist,
} from '@/api/consts';


export default {
  name: "RegisterPage",
  data() {
    return {
      active: 0,
      mobile: "",
      code: "",
      password: "",
      rePassword: "",
      agree: true,

      name: "",
      realStatus: 0,
      authStatus:0,
      email: "",
      nickname: "",
      staffNum: "",
    };
  },

  mounted() {
    this.parseQueryUrl();
  },

  methods: {
    parseQueryUrl() {
      const parts = this.$route.fullPath.split("?");
      if (parts.length < 2) {
        return
      }
      const that = this;
      const paramPairs = parts[1].split("&");
      paramPairs.forEach(paramPair => {
        const [key, value] = paramPair.split("=");
        if (key === "mobile") {
          that.mobile = value;
        } else if (key === "code") {
          that.code = value;
        } else if (key === "step") {
          that.active = parseInt(value);
        }
      });
    },

    handleGetVerifyCode() {
      if (!this.testMobile()) {
        return
      }

      const data = JSON.stringify({
        "mobile": this.mobile
      });
      
      getVerifyCode(data).then(() => {
        this.$message.info("请求已发送，请稍候...");
      })
      .catch(error => {
        console.error("错误信息：", error);
      });
    },

    async handleRegister() {
      if (!this.testMobile() || !this.testCode() || !this.testAgreement()) {
        return false;
      }

      const raw = JSON.stringify({
        "mobile": this.mobile,
        "code": this.code,
      });
      
      try {
        let result = await register(raw);
        console.log(result)
        if (result.data.code === ErrorRegisterExist) {
          this.$message.error("您输入的手机号已经注册");
          return false;
        }
        if (result.data.data.realStatus == 0 && result.data.data.authData.authUrl) {
          // 未授权，跳至授权入口
          window.location = `/frame-register?url=${encodeURIComponent(result.data.data.authData.authUrl)}`;
          return true;
        }
        if (result.data.data.realStatus == 1) {
          // 已经授权，直接跳至成功
          this.active = 1;
          return true;
        }
      }catch(e) {
        console.error("错误信息：", e);
        this.$message.error("注册账号失败");
        return false;
      }
    },

    async handleSetPassword() {
      if (!this.testPassword() || !this.testCode() || !this.testAgreement()) {
        return false;
      }

      const data = JSON.stringify({
        "mobile": this.mobile,
        "password": this.password,
        "code": this.code,
      });

      try {
        let result = await registerPassword(data);
        console.log(result);
        if (result.data.code === 0) {
          this.$message.info("设置密码成功");
          this.active = 2;
          return true;
        }
        if (result.data.code === 121) {
          this.$message.error("您输入的手机号已经注册");
          return false;
        }
        this.$message.error("设置密码失败");
      }catch(e) {
        console.log(e);
      }
      return false;
    },

    testMobile() {
      this.mobile = this.mobile.trim();
      if (this.mobile == "") {
        this.$message.error("手机号不能为空");
        return false
      }
      if (this.mobile.length != 11) {
        this.$message.error("手机号长度不正确");
        return false
      }
      const reg = /^1[0-9]{10}$/;
      if (!reg.test(this.mobile)) {
        this.$message.error("手机号格式不正确");
        return false
      }
      return true
    },

    testCode() {
      this.code = this.code.trim();
      if (this.code == "") {
        this.$message.error("验证码不能为空");
        return false
      }
      if (this.code.length != 4) {
        this.$message.error("验证码长度不正确");
        return false
      }
      return true
    },

    testPassword() {
      this.password = this.password.trim();
      if (this.password == "") {
        this.$message.error("密码不能为空");
        return false
      }
      this.rePassword = this.rePassword.trim();
      if (this.rePassword == "") {
        this.$message.error("请再次输入密码确认");
        return false
      }
      if (this.rePassword != this.password) {
        this.$message.error("两次输入的密码不同");
        return false
      }
      return true
    },

    testAgreement() {
      if (!this.agree) {
        this.$message.error("请首先选择同意《服务协议》");
        return false
      }
      return true
    },

    goHome(){
      window.location = "/";
    },
  },
};
</script>

<style scoped>
/deep/ .el-step__title {
  font-weight: normal;
  font-size: 14px;
}
/deep/ .el-step__title.is-process {
  font-weight: normal;
  font-size: 14px;
}
</style>